import React from "react"
import styled from 'styled-components'
import { Title, Item } from '../../../shared/Section'

const Wrapper = styled.div`
  font-size: 1.4rem;
`

const Paragraph = styled.p`
  span {
    display: block;
    line-height: 2.0;
  }
  & + & {
    margin-top: 3.2rem;
  }
`

const Message = () => {
  return (
    <>
      {/* <Content title={"Concept"}> */}
      <Title>Message</Title>
      <Item>
        <Wrapper>
            <Paragraph>
              <span>卒業制作。 </span>
              <span>ずっと先のことだと思っていました。 </span>
            </Paragraph>
            <Paragraph>
              <span>入学してから今日まで。 </span>
              <span>私たちは出会い、日々悩み、生み出し、触れ合い、また作るを繰り返してきました。</span>
            </Paragraph>
            <Paragraph>
              <span>私たちのこの学生生活は、貴重で大切で、忘れられない時間でした。</span>
            </Paragraph>
            <Paragraph>
              <span>その最後。</span>
              <span>2020年という1年の中で、予想も出来ない状況でも、先が見えなくても、私たちは最後まで作り続けてきました。</span>
              <span>不安でも。寂しくても。</span>
            </Paragraph>
            <Paragraph>
              <span>1年間、暗闇の中でも作り続けた私達なら。</span>
              <span>私達だから、この先もそれぞれの場所でこれからを生み出していける。</span>
            </Paragraph>
            <Paragraph>
              <span>わたしたちは 出逢い、見つめ、創り出す。</span>
              <span>日々を重ね、区切り、別れる。</span>
              <span>つくり、つづり、つづく。</span>
            </Paragraph>
            <Paragraph>
              <span>「そして、」</span>
            </Paragraph>
        </Wrapper>
      </Item>
      {/* </Content> */}
    </>
  )
}

export default Message